import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CookiesBanner = () => {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('cookiesAccepted')) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const close = (value: 'true' | 'false') => {
    localStorage.setItem('cookiesAccepted', value);
    setLeaving(true);
    setTimeout(() => setVisible(false), 280);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-[88] p-4 md:px-6 transition-all duration-300 ${leaving ? 'opacity-0 translate-y-full' : 'opacity-100 translate-y-0'}`}
      style={{ transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)' }}
      role="dialog"
      aria-label="Aviso de cookies"
    >
      <div className="max-w-3xl mx-auto bg-ink text-paper rounded-[4px] border border-paper/15 p-5 md:p-6 shadow-[0_24px_60px_-20px_rgba(22,19,15,0.55)]">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-5">
          <div className="flex-1">
            <p className="text-sm font-semibold tracking-tight">🍪 Uso de cookies</p>
            <p className="text-xs text-paper/55 mt-1.5 leading-relaxed">
              Usamos cookies para medir el rendimiento de la web y mejorar tu experiencia.
              No vendemos tus datos. Puedes aceptarlas o rechazarlas sin problema.
            </p>
            <Link to="/politica-de-privacidad" className="link-underline text-[0.7rem] font-semibold text-paper/70 mt-2 inline-block">
              Política de privacidad
            </Link>
          </div>
          <div className="flex gap-2.5 shrink-0 w-full md:w-auto">
            <button onClick={() => close('false')} className="btn border border-paper/30 text-paper flex-1 md:flex-none !px-4 !py-2.5 text-[0.68rem]">
              Rechazar
            </button>
            <button onClick={() => close('true')} className="btn bg-clay text-white flex-1 md:flex-none !px-5 !py-2.5 text-[0.68rem]">
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;
